(() => {
  function initialize(root) {
    const forms = root.querySelectorAll("form.as-card-complementary-form");
    forms.forEach((form) => {
      if (form.dataset.cardComplementaryInitialized === "true") return;
      form.dataset.cardComplementaryInitialized = "true";

      const productForm = form.closest("product-form");
      if (!productForm) {
        console.error("Card complementary products: product form wrapper was not found.");
        return;
      }

      let indices;
      try {
        indices = JSON.parse(productForm.dataset.cardFreeGiftIndices || "[]");
      } catch (error) {
        console.error("Card complementary products: free accessory indices are invalid.", error);
        indices = [];
      }

      if (!Array.isArray(indices) || indices.length === 0) {
        form.dataset.cardComplementaryVariantIds = "";
        form.dataset.cardComplementaryReady = "true";
        return;
      }

      const recommendationRequest = fetch(productForm.dataset.cardComplementaryUrl, {
        headers: { Accept: "application/json" },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Recommendation request failed with status ${response.status}.`);
          }
          return response.json();
        })
        .then((data) => {
          if (!Array.isArray(data.products)) {
            throw new Error("Recommendation response did not include a products list.");
          }

          const variantIds = indices
            .map((index) => data.products[Number(index) - 1])
            .filter((product) => product && product.available !== false)
            .map((product) => product.variants?.find((variant) => variant.available)?.id)
            .filter(Boolean);

          form.dataset.cardComplementaryVariantIds = variantIds.join(",");
        })
        .catch((error) => {
          console.error("Card complementary products could not be loaded.", error);
          form.dataset.cardComplementaryVariantIds = "";
        })
        .finally(() => {
          form.dataset.cardComplementaryReady = "true";
        });

      form.addEventListener(
        "submit",
        (event) => {
          if (form.dataset.cardComplementaryReady === "true") return;

          event.preventDefault();
          event.stopImmediatePropagation();
          if (form.dataset.cardComplementarySubmitPending === "true") return;

          form.dataset.cardComplementarySubmitPending = "true";
          const submitter = event.submitter;
          recommendationRequest.then(() => {
            form.dataset.cardComplementarySubmitPending = "false";
            if (!form.isConnected) return;
            if (submitter) {
              form.requestSubmit(submitter);
            } else {
              form.requestSubmit();
            }
          });
        },
        true
      );
    });
  }

  initialize(document);
  document.addEventListener("shopify:section:load", (event) => initialize(event.target));
})();
